exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".word-no-break[data-v-258c0604]{word-break:break-word}.use-list[data-v-258c0604]{list-style:none}.use-list li[data-v-258c0604]{position:relative}.use-list li[data-v-258c0604]:before{content:\"\\25A0\";color:#ff8100;position:absolute;left:-20px}.custom-border-bt[data-v-258c0604]{border-bottom:2px solid #d9d9d9}@media (max-width: 767px){.custom-border-bt[data-v-258c0604]:last-child{border:none}}\n", ""]);

// exports
